import { render, staticRenderFns } from "./AnalysesCategoryCard.vue?vue&type=template&id=43675b7a&scoped=true&"
import script from "./AnalysesCategoryCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesCategoryCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesCategoryCard.vue?vue&type=style&index=0&id=43675b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43675b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43675b7a')) {
      api.createRecord('43675b7a', component.options)
    } else {
      api.reload('43675b7a', component.options)
    }
    module.hot.accept("./AnalysesCategoryCard.vue?vue&type=template&id=43675b7a&scoped=true&", function () {
      api.rerender('43675b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesCategoryCard.vue"
export default component.exports